import axios from 'axios';
import apiUsageTracker from './apiUsageTracker';

// Create axios interceptor for automatic API tracking
const createApiInterceptor = (axiosInstance) => {
  // Request interceptor to track start time
  axiosInstance.interceptors.request.use(
    (config) => {
      config.metadata = { startTime: Date.now() };
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Build full URL for tracking (axios config.url is relative when baseURL is set)
  const getFullUrl = (config) => {
    const base = (config.baseURL || '').replace(/\/+$/, '');
    const path = (config.url || '').replace(/^\/+/, '');
    if (!base) return path || config.url || '';
    return path ? `${base}/${path}` : base;
  };

  // Response interceptor to track API usage
  axiosInstance.interceptors.response.use(
    (response) => {
      const endTime = Date.now();
      const responseTime = endTime - response.config.metadata.startTime;
      const fullUrl = getFullUrl(response.config);
      apiUsageTracker.trackApiCall(fullUrl, response.config.method, responseTime, true);
      return response;
    },
    (error) => {
      const endTime = Date.now();
      const responseTime = error.config?.metadata?.startTime
        ? endTime - error.config.metadata.startTime
        : 0;
      if (error.config) {
        const fullUrl = getFullUrl(error.config);
        apiUsageTracker.trackApiCall(fullUrl, error.config.method, responseTime, false);
      }
      return Promise.reject(error);
    }
  );

  return axiosInstance;
};

// Enhanced axios instance with tracking
const createTrackedAxiosInstance = (baseConfig = {}) => {
  const instance = axios.create(baseConfig);
  return createApiInterceptor(instance);
};

export { createApiInterceptor, createTrackedAxiosInstance };
export default createApiInterceptor;
